import React from 'react'

import {AttendanceVisualSummary} from '../../../../modes/attendance/buildAttendanceVisualSummary'
import AttendancePlainCard from '../AttendancePlainCard'
import AttendanceStatusBars from '../AttendanceStatusBars'
import AttendanceSummaryRing from '../AttendanceSummaryRing'

type AttendanceV2VisualSummaryProps = {
  summary: AttendanceVisualSummary
  theme: 'light' | 'dark'
}

const AttendanceV2VisualSummary: React.FC<AttendanceV2VisualSummaryProps> = ({summary, theme}) => {
  const {
    mode,
    statusSegments,
    presentPercent,
    statPairs,
    totalRecords,
    headlineLabel,
    barSegments,
  } = summary
  const showRing = statusSegments.length > 0

  if (mode === 'stats' && !showRing) {
    // `'0%'` used to be filtered out alongside `'0'`, to hide a fake rate `statsToSummary` invented
    // by coercing a suppressed percentage to zero. That coercion is gone, so the clause now only
    // hides a genuine 0% — a class where nobody attended, which is exactly when it matters most.
    const pairs = statPairs.filter((pair) => pair.value && pair.value !== '0')
    if (!pairs.length) return null
    return (
      <div className='mb-2'>
        <AttendancePlainCard pairs={pairs} theme={theme} />
      </div>
    )
  }

  if (!showRing) return null

  // Ring and bars already carry both the headline figure and every per-status count, so the
  // count caption and status pills that used to sit here only repeated them.
  return (
    <div className='attendance-v2-visual-summary mb-2'>
      <div className='d-flex align-items-center gap-3 flex-wrap'>
        <AttendanceSummaryRing
          segments={statusSegments}
          presentPercent={presentPercent}
          totalRecords={totalRecords}
          theme={theme}
          headlineLabel={headlineLabel}
        />
        <div className='flex-grow-1 min-w-0'>
          <AttendanceStatusBars segments={statusSegments} theme={theme} barSegments={barSegments} />
        </div>
      </div>
    </div>
  )
}

export default AttendanceV2VisualSummary
